import { styled, Theme } from '@mui/material';

export const sxStyles = {
  tuitionCostContainer: {
    marginTop: '4rem',
  },
  tuitionCostSectionTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  costAveragesTitle: (theme: Theme) => ({
    padding: '1.25rem 2rem',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  costItemWrap: {
    marginTop: '1rem',
  },
  costItemTitle: {
    marginBottom: '2px',
  },
  averageCostOfAttendanceWrap: {
    marginBottom: '2rem',
  },
  costsPerYear: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  onCampusHousing: {
    display: 'flex',
    marginTop: '1rem',

    '& > div:first-of-type': {
      marginRight: '0.75rem',
    },
  },
  calculateTheCost: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.75rem 4.75rem 1.75rem 3.5rem',
  },
};

export const StyledTuitionCostWrap = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
  marginTop: '2.25rem',
  boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
  borderRadius: '0.5rem',
}));

export const StyledTuitionCostInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  margin: '0 4.75rem 0 3.5rem',
  padding: '3.5rem 0 2.125rem 0',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  '& > div:last-of-type': {
    marginLeft: '1rem',
  },

  [theme.breakpoints.down('md')]: {
    margin: '0 2rem',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',

    '& > div:last-of-type': {
      marginLeft: 0,
      marginTop: '2.5rem',
    },
  },
}));

export const StyledAverageCostOfAttendanceTitle = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: '1rem',

  '& > div:last-of-type': {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.75rem',
    cursor: 'pointer',
  },
}));

export const StyledCalculateCostWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '1.75rem 4.75rem 1.75rem 3.5rem',

  [theme.breakpoints.down('md')]: {
    padding: '1.75rem 2rem',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'start',
    padding: '1.75rem 2rem',

    '& > a:first-of-type': {
      marginTop: '1rem',
      marginLeft: 0,
    },
  },
}));

export const StyledCalculateCostLink = styled('a')(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  padding: '0.25rem 1.125rem',
  borderRadius: '2px',
  fontSize: '0.75rem',
  fontWeight: 600,
  minWidth: '142px',
  marginLeft: '2rem',

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.dark,
  },
}));
